import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Form, Button, Modal } from "react-bootstrap";
import axios from "axios";
import { environment } from "../../environment.js";
import { LinkContainer } from "react-router-bootstrap";
import Loader from "../Components/Loader.js";
import Select from "react-select";
import Toggle from "react-toggle";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import Dropdown from "react-bootstrap/Dropdown";
import { fontSize } from "@mui/system";
import NavbarNew from "../Components/NavbarNew.js";
const { SearchBar } = Search;

const MySwal = withReactContent(Swal);

const QuestionsAll = () => {
  const [questions, setQuestions] = useState([]);
  const [question_details, setQuestionDetail] = useState({});
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
  };
  useEffect(() => {
    fetchQuestions();
  }, []);

  const userType = JSON.parse(localStorage.getItem("userDetails")).data.authority;

  const fetchQuestions = () => {
    axios
      .get(environment.dap_url + "questionnarieApi/getQuestionssys")
      .then((res) => {
        const result = res.data.reverse();
        console.log(result);
        const salesResult = [...result].filter((item) => item.team === "Sales");
        const supportResult = [...result].filter((item) => item.team === "Support");

        if (userType === "leadexecutive" || userType === "manager") {
          setQuestions(salesResult);
        }else if (userType === "supportadmin" || userType === "itexecutive") {
          setQuestions(supportResult);
        } else {
          setQuestions(result);
        }
      })
      .catch(function (error) {
        console.log(error);
        MySwal.fire({
          title: <p>{error.message}</p>,
          type: "error",
        });
      });
  }

  const getquestion = (_id) => {
    axios
      .get(environment.dap_url + "questionnarieApi/getQuestionByid?id=" + _id)
      .then((res) => {
        // console.log("abcdef", res.data[0].question);
        setQuestionDetail(res.data);
        handleShow();
      })
      .catch(function (error) {
        MySwal.fire({
          title: <p>{error.message}</p>,
          type: "error",
        });
      });
  };

  //This is for deletion of questions
  const deleteHandler = (_id) => {
    // alert(_id);
    // console.log(id);
    MySwal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(function (result) {
      if (result.isConfirmed) {
        axios
          .delete(environment.dap_url + "questionnarieApi/deleteQuestionWithId/" + _id)
          .then((res) => {
            MySwal.fire({
              title: <p>Question has been successfully deleted!</p>,
              type: "success",
            });
            fetchQuestions();
          })

          .catch((err) => {
            MySwal.fire({
              title: (
                <p>{err?.response?.data?.message || "Question  deletion failed"}</p>
              ),
              type: "error",
            });
          });
      }
    });
  };
  let industriestype = [];
    industriestype = [
        {
        roleType: "All",
        roleId: 0,
        },
        {
        roleType: "Corporate",
        roleId: 1,
        },
        {
        roleType: "Education",
        roleId: 2,
        },
        {
        roleType: "Healthcare",
        roleId: 3,
        },
        {
        roleType: "Hospitality",
        roleId: 4,
        },
        {
        roleType: "Manufacturing",
        roleId: 5,
        },
        {
        roleType: "Others",
        roleId: 6,
        },
    ];

    const industryMap = Object.fromEntries(
  industriestype.map((item) => [item.roleId, item.roleType])
);

  const columns = [
    {
      dataField: "sl.no",
      text: "#",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
      sort: true,
    },
    {
      dataField: "question",
      text: "Question",
      sort: true,
    },
    {
      dataField: "questionType",
      text: "Question Type",
      sort: true,
    },
    {
      dataField: "questionMasterId",
      text: "Feedback Question Type",
      sort: true,
      formatter: (cell, row) => {
        if (row.questionMasterId === 1) return "Awareness";
        else if (row.questionMasterId === 2) return "Current Usage Experience";
        else return "Voluntary Questions";
      },
    },
    {
      dataField: "industryId",
      text: "Industry Type",
      sort: true,
      formatter: (cell, row) => industryMap[row.industryId] || "N/A",
    },
    {
      dataField: "team",
      text: "Team",
      sort: true,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return questions[rowIndex].team;
      },
    },
    {
      dataField: "_id",
      text: "Action",
      sort: false,
      formatter: (dataField) => {
        return (
          <div>
            <Button
              variant="primary"
              className="btn-sm"
              onClick={() => getquestion(dataField)}
            >
              <i className="fa fa-eye"></i>
            </Button>

            {userType == "SYS_ADMIN" ? (
              <LinkContainer to={`/editQuestion/` + dataField}>
                <Button variant="info" className="btn-sm">
                  <i className="fa fa-edit"></i>
                </Button>
              </LinkContainer>
            ) : ""}

            {userType == "SYS_ADMIN" ? (
              <Button
                variant="danger"
                className="btn-sm"
                onClick={() => deleteHandler(dataField)}
              >
                <i className="fa fa-trash"></i>
              </Button>
            ) : ""}
          </div>
        );
      },
    },
  ];
  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ];
  return (
    <div>
      <>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Question</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table class="table table-bordered">
              <tbody>
                <tr>
                  {/* <th width="50%" scope="row">
                    Question
                  </th> */}
                  <td style={{ fontSize: "15px" }}>
                    Q. {question_details[0] && question_details[0].question}
                  </td>
                </tr>
                <tr>
                  <td>
                    <ul>
                      {question_details[0] &&
                        question_details[0].answerOptions.map(
                          (option, index) => (
                            <li key={index}>
                              {option.option} - {option.waitage}
                            </li>
                          )
                        )}
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <div className="container-fluid">
          <NavbarNew />
          <h4 className="card-title">QUESTIONS</h4>

          <ToolkitProvider
            keyField="id"
            bootstrap4
            data={questions}
            columns={columns}
            search
          >
            {(props) => (
              <div>
                <div className="d-flex align-items-center">
                  <p className="mb-2 mr-2">Search in table:</p>
                  <SearchBar {...props.searchProps} />
                </div>
                <BootstrapTable
                  pagination={paginationFactory()}
                  {...props.baseProps}
                  wrapperClasses="table-responsive"
                />
              </div>
            )}
          </ToolkitProvider>
        </div>
      </>
    </div>
  );
};
export default QuestionsAll;
